import React, { useState, useEffect } from 'react';
import SharedButton from './SharedButton';

const periodicityLabels = {
  once:       'Única vez',
  weekly:     'Semanal',
  monthly:    'Mensual',
  semiannual: 'Semestral',
};

// FIX: parsear fecha local para evitar el bug del día anterior
// new Date('YYYY-MM-DD') la interpreta como UTC → se muestra un día antes
// new Date(y, m-1, d) la interpreta como local → correcto
const parseLocalDate = dateStr => {
  if (!dateStr) return new Date();
  const [y, m, d] = dateStr.split('-').map(Number);
  return new Date(y, m - 1, d);
};

const occursOn = (event, date) => {
  const evDate = parseLocalDate(event.date);
  switch (event.periodicity) {
    case 'once':
      return evDate.toDateString() === date.toDateString();
    case 'weekly':
      return evDate.getDay() === date.getDay();
    case 'monthly':
      return evDate.getDate() === date.getDate();
    case 'semiannual': {
      const monthDiff =
        (date.getFullYear() - evDate.getFullYear()) * 12 +
        (date.getMonth() - evDate.getMonth());
      return evDate.getDate() === date.getDate() && monthDiff >= 0 && monthDiff % 6 === 0;
    }
    default:
      return false;
  }
};

const CalendarListView = ({ events, onEdit, onDelete, onSelectEvent }) => {
  const [filterDate,    setFilterDate]    = useState('');
  const [filteredEvents,setFilteredEvents]= useState([]);

  useEffect(() => {
    if (filterDate) {
      const dateObj = parseLocalDate(filterDate);
      setFilteredEvents(events.filter(ev => occursOn(ev, dateObj)));
    } else {
      setFilteredEvents(
        [...events].sort((a, b) => {
          const da = parseLocalDate(a.date); da.setHours(...a.time.split(':').map(Number), 0);
          const db = parseLocalDate(b.date); db.setHours(...b.time.split(':').map(Number), 0);
          return da - db;
        })
      );
    }
  }, [events, filterDate]);

  return (
    <div className="mb-6">
      <div className="mb-4">
        <label className="block text-xs font-semibold text-gray-600 mb-1">Filtrar por fecha</label>
        <input
          type="date"
          value={filterDate}
          onChange={e => setFilterDate(e.target.value)}
          className="px-3 py-2 border border-gray-200 rounded-lg text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#961914]/30"
        />
        {filterDate && (
          <button onClick={() => setFilterDate('')} className="ml-2 text-xs text-gray-400 hover:text-gray-600 underline">
            Limpiar
          </button>
        )}
      </div>

      {filteredEvents.length === 0 ? (
        <p className="text-center text-gray-400 py-8 text-sm">No hay eventos.</p>
      ) : (
        <div className="space-y-2">
          {filteredEvents.map(ev => {
            const isSchedule = ev.type === 'schedule';
            // FIX: usar parseLocalDate para mostrar la fecha correcta
            const dateLabel = parseLocalDate(ev.date).toLocaleDateString('es-MX', {
              weekday: 'short', year: 'numeric', month: 'short', day: 'numeric'
            });
            return (
              <div
                key={ev.id + '_' + (filterDate || ev.date)}
                onClick={() => onSelectEvent(ev)}
                className={`p-4 rounded-xl shadow-sm border cursor-pointer transition-colors hover:shadow-md ${
                  isSchedule
                    ? 'bg-blue-50 border-blue-200'
                    : 'bg-white border-gray-200 hover:border-[#961914]/30'
                }`}
              >
                <div className="flex justify-between items-start gap-2">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="font-semibold text-sm text-gray-900">
                        {ev.time} — {ev.subdiscipline}
                      </span>
                      <span className="px-2 py-0.5 bg-gray-100 text-gray-500 text-xs rounded-full">
                        {periodicityLabels[ev.periodicity] || ev.periodicity}
                      </span>
                      {isSchedule && (
                        <span className="px-2 py-0.5 bg-blue-100 text-blue-600 text-xs rounded-full">
                          Horario de clase
                        </span>
                      )}
                    </div>
                    <p className="text-xs text-gray-500 mt-1">
                      Nivel: {ev.level} · Maestro: {ev.teacher} · {dateLabel}
                    </p>
                  </div>
                  {!isSchedule && (
                    <div className="flex gap-1 flex-shrink-0" onClick={e => e.stopPropagation()}>
                      <button
                        onClick={() => onEdit(ev)}
                        className="px-2 py-1 text-xs font-semibold bg-blue-50 text-blue-700 hover:bg-blue-100 rounded-lg transition-colors"
                      >
                        Editar
                      </button>
                      <button
                        onClick={() => onDelete(ev.id)}
                        className="px-2 py-1 text-xs font-semibold bg-red-50 text-red-700 hover:bg-red-100 rounded-lg transition-colors"
                      >
                        Eliminar
                      </button>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CalendarListView;